/**
 * Sunshine hours data by country (annual average)
 * Sources: World Meteorological Organization, Climate data
 */

// Average annual sunshine hours by country code
export const sunshineHoursByCountry: Record<string, number> = {
    // Global average
    WLD: 2000,

    // Top life expectancy countries
    JPN: 1900,
    CHE: 1700,
    KOR: 2100,
    SGP: 2000,
    ESP: 2800,
    ITA: 2500,
    AUS: 2600,
    ISL: 1300,
    ISR: 3300,
    SWE: 1800,
    FRA: 2000,
    NOR: 1600,
    LUX: 1600,
    NLD: 1650,
    CAN: 2000,
    NZL: 2000,
    AUT: 1900,
    FIN: 1800,
    IRL: 1400,
    BEL: 1550,
    PRT: 2800,
    DEU: 1600,
    GBR: 1400,
    DNK: 1800,
    GRC: 2800,

    // Americas
    USA: 2500,
    CHL: 2400,
    CRI: 2200,
    CUB: 2700,
    URY: 2400,
    ARG: 2500,
    MEX: 2600,
    BRA: 2200,
    COL: 1800,
    PER: 2000,

    // Asia
    CHN: 2000,
    HKG: 1900,
    MAC: 1900,
    TWN: 1800,
    THA: 2200,
    MYS: 2200,
    VNM: 2000,
    PHL: 2200,
    IDN: 2400,
    IND: 2600,
    BGD: 2500,
    PAK: 3000,
    LKA: 2400,
    NPL: 2200,

    // Middle East
    ARE: 3500,
    QAT: 3400,
    KWT: 3300,
    SAU: 3200,
    TUR: 2700,
    IRN: 2900,
    JOR: 3200,
    LBN: 2900,

    // Europe (additional)
    POL: 1700,
    CZE: 1700,
    HUN: 2000,
    ROU: 2100,
    RUS: 1700,
    UKR: 1900,

    // Africa
    ZAF: 2500,
    MAR: 3000,
    TUN: 3000,
    EGY: 3500,
    KEN: 2500,
    GHA: 2200,
    NGA: 2300,
    ETH: 2500,

    // Oceania
    FJI: 2200,
};

/**
 * Get sunshine hours for a country
 */
export function getSunshineHours(countryCode: string): number {
    return sunshineHoursByCountry[countryCode] || sunshineHoursByCountry.WLD;
}
